import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const SourcingAuctionBuyerStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;
  padding: 20px 20px 0 20px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1280px;

  .auction-wrapper {
    background-color: ${VARIABLES.COLORS.WHITE};
    padding: 20px;
    border-radius: 6px 6px 0px 0px;
    border: 1px solid #e5e5e5;
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .table-column-head {
    height: 60px;
  }

  .logo-wrapper {
    padding: 0;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: ${VARIABLES.COLORS.BLUE_1};
    justify-content: center;
    margin-right: 17px;
  }

  .button-top-page {
    width: 100%;
    margin-bottom: 20px;
    justify-content: end;
  }

  .auction-title {
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    color: ${VARIABLES.COLORS.BLUE_1};
    padding: 10px 0 20px 10px;
    align-items: center;
  }

  .auction-dashboard {
    background-color: ${VARIABLES.COLORS.WHITE};
    padding: 20px;
    border-radius: 6px 6px 0px 0px;
    border: 1px solid #e5e5e5;
    display: block;
  }

  .event-no {
    padding-left: 20px;
    width: 100%;
    height: auto;
    align-items: center;
    background: linear-gradient(100deg, #4b4acb 12%, #ffffff 100%);
    color: white;
    font-size: 24px;
    flex-direction: column;
    padding-top: 1rem;
    padding-bottom: 1rem;

    .title {
      margin-right: 8px;
    }
  }

  .auction-info {
    margin-bottom: 20px;
    border: 1px solid #e8e8e8;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.06);
    border-radius: 6px;
    padding: 20px;
    line-height: 2.5;
    display: block;

    .row {
      /* width: 100%; */
      .column {
        /* width: 70%; */
        width: 50%;
        font-size: 20px;
        display: flex;
        column-gap: 10px;
        .title {
          color: ${VARIABLES.COLORS.BLUE_1};
          margin-right: 5px;
        }
        .detail {
        }
        .primary {
          padding: 10px 20px 10px 20px;
        }
      }
      .column:nth-child(2) {
        /* width: 30%; */
      }
      .column:last-child {
        padding-left: calc(50% - 370px);
      }

      @media only screen and (max-width: 991.98px) {
        .column {
          font-size: 16px;
        }

        .column:last-child {
          padding-left: 0;
        }
      }
    }
  }

  .bid-summary-title,
  .bid-history-title {
    padding-left: 20px;
    width: 100%;
    height: 80px;
    align-items: center;
    background: linear-gradient(100deg, #4b4acb 12%, #ffffff 100%);
    color: white;
    font-size: 24px;
    .title {
      margin-right: 10px;
    }
  }

  .bid-summary-list,
  .bid-history-list {
    margin-bottom: 20px;
    .list {
      display: block;
      max-height: 400px;
      overflow: auto;
      overflow-y: overlay;
      ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: ${VARIABLES.COLORS.GRAY_2};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: ${VARIABLES.COLORS.BLUE_4};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: ${VARIABLES.COLORS.BLUE_1};
      }
    }
    .summary-hammer {
      flex: 0 0 3%;
    }
    .summary-ranking-no {
      flex: 0 0 8%;
      justify-content: center;
      text-align: center;
    }
    .summary-supplier-name {
      flex: 0 0 20%;
    }
    .summary-bidding-amount {
      flex: 0 0 20%;
      justify-content: end;
      text-align: right;
    }
    .summary-bidding-time {
      flex: 0 0 20%;
      justify-content: center;
      text-align: center;
    }
    .summary-no-of-bids {
      justify-content: center;
      text-align: center;
    }
    .summary-status {
      flex: 0 0 10%;
      justify-content: center;
      text-align: center;
    }
    .summary-view-more {
    }
    .center {
      justify-content: center;
      text-align: center;
    }
    .hammer {
      width: 38px;
    }
    .status-online {
      color: #16a651;
    }
    .status-offline {
      color: #ce1f0f;
    }
    .history-bidding-no {
      flex: 0 0 20%;
      justify-content: center;
      text-align: center;
    }
    .history-supplier-name {
      flex: 0 0 25%;
    }
    .history-bidding-amount {
      flex: 0 0 25%;
      justify-content: end;
      text-align: right;
    }
    .history-bidding-time {
      flex: 0 0 30%;
    }
  }

  .bid-time-left {
    margin-bottom: 20px;
    flex-direction: column;
    background-color: #fbe5e4;
    padding: 20px;
    justify-content: center;
    align-items: center;
    height: 150px;
    .title {
      font-size: 28px;
      color: ${VARIABLES.COLORS.BLUE_1};
      margin-bottom: 10px;
    }
    .time-red {
      color: #ce1f0f !important;
    }
    .time-left-group {
      width: fit-content;
      color: #4b4acb;
      label {
        font-size: 15px;
        color: ${VARIABLES.COLORS.GRAY_3};
      }
      .milliseconds {
        margin-left: -10px;
      }
      .time-left {
        flex-direction: column;
        align-items: center;
        width: 90px;
        .time {
          display: flex;
          justify-content: center;
          align-items: center;
          line-height: 0;
          /* width: 50px; */
          height: 50px;
          /* color: #4b4acb; */
          font-size: 48px;
        }
      }
      .separator {
        justify-content: center;
        .time {
          display: flex;
          justify-content: center;
          align-items: center;
          line-height: 0;
          height: 50px;
          /* color: #4b4acb; */
          font-size: 48px;
        }
      }
    }
  }

  /* Child element styles
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media only screen and (min-width: 1400px) {
    max-width: 1520px;
  }
`

export const SourcingAuctionSupplierStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;
  padding: 20px 20px 0 20px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1280px;

  @media only screen and (min-width: 1400px) {
    max-width: 1520px;
  }

  .input-total-price {
    flex-wrap: wrap;
    input {
      color: ${VARIABLES.COLORS.BLUE_1};
    }
    &.is-error {
      input {
        color: ${VARIABLES.COLORS.RED_1};
        border: 1px solid red;
      }
      .message {
        color: ${VARIABLES.COLORS.RED_1};
        opacity: 1;
        font-size: 14px;
        white-space: normal;
      }
    }
    .message {
      opacity: 0;
    }
  }

  .disable-icon {
    filter: grayscale(1) contrast(80%);
  }

  .auction-wrapper {
    margin-bottom: 20px;
    background-color: ${VARIABLES.COLORS.WHITE};
    padding: 20px;
    border-radius: 6px 6px 0px 0px;
    border: 1px solid #e5e5e5;
    display: block;
    width: 100%;
  }

  .logo-wrapper {
    padding: 0;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: ${VARIABLES.COLORS.BLUE_1};
    justify-content: center;
    margin-right: 17px;
  }

  .button-top-page {
    width: 100%;
    margin-bottom: 20px;
    justify-content: end;
  }

  .auction-title {
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    color: ${VARIABLES.COLORS.BLUE_1};
    padding: 10px 0 20px 10px;
    align-items: center;
  }

  .auction-dashboard {
    background-color: ${VARIABLES.COLORS.WHITE};
    padding: 20px;
    border-radius: 6px 6px 0px 0px;
    border: 1px solid #e5e5e5;
    display: block;
  }

  .event-no {
    padding-left: 20px;
    width: 100%;
    height: auto;
    align-items: center;
    background: linear-gradient(100deg, #4b4acb 12%, #ffffff 100%);
    color: white;
    font-size: 24px;
    flex-direction: column;
    padding-top: 1rem;
    padding-bottom: 1rem;

    .title {
      margin-right: 8px;
    }
  }

  .icon-trapezoid {
    width: 2.625em;
  }

  .form-group {
    & > .button {
      margin-top: 0;
    }
  }

  .auction-info {
    margin-bottom: 20px;
    border: 1px solid #e8e8e8;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.06);
    border-radius: 6px;
    padding: 20px;
    line-height: 2.5;
    display: block;

    .row {
      /* width: 100%; */
      .column {
        /* width: 70%; */
        width: 50%;
        font-size: 20px;
        display: flex;
        column-gap: 10px;
        .title {
          color: ${VARIABLES.COLORS.BLUE_1};
          margin-right: 5px;
        }
        .detail {
        }
        .primary {
          padding: 10px 20px 10px 20px;
        }
      }
      .column:nth-child(2) {
        /* width: 30%; */
      }

      .column:last-child {
        padding-left: calc(50% - 370px);
      }

      @media only screen and (max-width: 991.98px) {
        .column {
          font-size: 16px;
        }

        .column:last-child {
          padding-left: 0;
        }
      }
    }
  }

  .submit-bid {
    margin: 20px 0 50px 0;
    flex-direction: column;
    align-items: end;
    .total-amount {
      display: block;
      color: ${VARIABLES.COLORS.BLUE_1};
      font-size: 24px;
      text-align: right;
      margin: 0 30px 20px 0;
    }
    .btn-submit {
      width: 180px;
    }
  }

  .bid-summary-title {
    padding-left: 20px;
    width: 100%;
    height: 80px;
    align-items: center;
    background: linear-gradient(100deg, #4b4acb 12%, #ffffff 100%);
    color: white;
    font-size: 24px;
    .title {
      margin-right: 10px;
    }
  }

  .history-left,
  .previous-right {
    border: 1px solid #e8e8e8;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.06);
    border-radius: 6px;
  }

  .bid-history-title {
    padding-left: 20px;
    width: 100%;
    height: 80px;
    align-items: center;

    color: ${VARIABLES.COLORS.BLUE_1};
    font-size: 24px;
    .title {
      margin-right: 10px;
    }
  }

  .bid-summary-list,
  .bid-history-list {
    margin-bottom: 20px;
    .list {
      display: block;
      max-height: 400px;
      overflow: auto;
      overflow-y: overlay;
      ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: ${VARIABLES.COLORS.GRAY_2};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: ${VARIABLES.COLORS.BLUE_4};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: ${VARIABLES.COLORS.BLUE_1};
      }
    }
    .no {
      justify-content: center;
      text-align: center;
      flex: 0 0 4%;
    }
    .item-name {
      flex: 0 0 18%;
      min-width: 160px;
      text-align: left;
      justify-content: left;
      word-wrap: break-word;
      hyphens: auto;
      white-space: normal;
      .item {
        margin-bottom: 10px;
        display: block;
      }
    }
    .description {
      flex: 0 0 20%;
      min-width: 160px;
      text-align: left;
      justify-content: left;
      word-wrap: break-word;
      hyphens: auto;
      white-space: normal;
      &-item {
        margin-bottom: 10px;
        display: block;
      }
    }
    .quantity {
      justify-content: end;
      text-align: right;
      flex: 0 0 10%;
    }
    .uom {
      justify-content: center;
      text-align: center;
      flex: 0 0 10%;
    }
    .unit-price {
      justify-content: end;
      text-align: right;
      flex: 0 0 14%;
    }
    .total-price {
      .input {
        text-align: right;
      }
      .input-control {
        flex: unset !important;
      }
      .message {
        padding-left: 14px;
        font-size: 14px;
        color: ${VARIABLES.COLORS.RED_1};
        opacity: 1;
        white-space: normal;
      }
    }
    .center {
      justify-content: center;
      text-align: center;
    }
    .hammer {
      width: 38px;
    }
    .status-online {
      color: #16a651;
    }
    .status-offline {
      color: #ce1f0f;
    }

    /* table Bid History ----------  */
    .history-bidding-no {
      /* flex: 0 0 16%; */
      justify-content: center;
      text-align: center;
    }
    .history-bidding-amount {
      flex: 0 0 30%;
      justify-content: end;
      text-align: right;
    }
    .history-bidding-time {
      flex: 0 0 35%;
      justify-content: center;
      text-align: center;
    }
    .history-view-more {
      /* flex: 0 0 16%; */
      justify-content: center;
      text-align: center;
    }

    /* table Your Previous Bid ---------------  */
    .previous-bidding-amount {
      flex: 0 0 50%;
      justify-content: end;
      text-align: right;
    }
    .previous-bidding-time {
      flex: 0 0 50%;
      justify-content: center;
      text-align: center;
    }
  }

  .hammer-green {
    width: 70px;
    margin-left: 20px;
    display: inline-block;
  }

  .bid-time-left {
    margin-bottom: 20px;
    flex-direction: column;
    background-color: #fbe5e4;
    padding: 20px;
    justify-content: center;
    align-items: center;
    height: 150px;
    .title {
      font-size: 28px;
      color: ${VARIABLES.COLORS.BLUE_1};
      margin-bottom: 10px;
    }
    .time-red {
      color: #ce1f0f !important;
    }
    .time-left-group {
      width: fit-content;
      color: #4b4acb;
      label {
        font-size: 15px;
        color: ${VARIABLES.COLORS.GRAY_3};
      }
      .milliseconds {
        margin-left: -10px;
      }
      .time-left {
        flex-direction: column;
        align-items: center;
        width: 90px;
        .time {
          display: flex;
          justify-content: center;
          align-items: center;
          line-height: 0;
          /* width: 50px; */
          height: 50px;
          /* color: #4b4acb; */
          font-size: 48px;
        }
      }
      .separator {
        justify-content: center;
        .time {
          display: flex;
          justify-content: center;
          align-items: center;
          line-height: 0;
          height: 50px;
          /* color: #4b4acb; */
          font-size: 48px;
        }
      }
    }
  }

  .auction-log {
    flex-direction: row;
    .history-left {
      flex: 0 0 58%;
      margin-right: 2%;
    }
    .previous-right {
      flex: 0 0 40%;
      height: fit-content;
      margin-bottom: 20px;
    }
  }

  .body-content-submit,
  .body-content-warning {
    margin: 20px 0 20px 0;
    justify-content: center;
    .text-detail-wrapper {
      display: block;
      width: fit-content;
      text-align: center;
      color: ${VARIABLES.COLORS.BLUE_1};
      label {
        font-size: 1.25em;
        font-weight: 500;
        line-height: 2.5;
        span {
          font-size: 1.6em;
        }
      }
    }
  }

  .modals-submit-bid-fail div.modal-custom-content {
    width: 700px;
  }

  .modals-submit-bid div.modal-custom-content {
    width: 700px;
  }
  /* Child element styles
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  /* Media queries
  
  ------------------------------- */
  @media all and (max-width: 1280.98px) {
    .total-price .form-group > .button {
      margin-left: 14px;
    }
  }

  @media all and (max-width: 1024px) {
    .auction-log {
      flex-direction: column;
      .history-left {
        flex: 0 0 1;
        order: 1;
      }
      .previous-right {
        flex: 0 0 1;
        order: 0;
      }
    }
  }
`
